// Приложение (PWA): сервис-воркер, установка на экран устройства. Состояние общее для всех страниц (Vue.observable).
import Vue from 'vue'

export const pwaState = Vue.observable({
  // браузер предлагает установить приложение (Chrome, Edge, Android)
  canInstall: false,
  // страница открыта как установленное приложение, без адресной строки
  standalone: false,
  // iPhone и iPad: установка вручную через «Поделиться → На экран «Домой»»
  ios: false,
  // сервис-воркер зарегистрирован (без него не работают офлайн-страница и push)
  worker: false
})

let installEvent = null

export function isStandalone() {
  try {
    return (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) || window.navigator.standalone === true
  } catch (e) {
    return false
  }
}

function detectIos() {
  const ua = window.navigator.userAgent || ''
  // iPadOS 13+ называет себя Macintosh, но имеет сенсорный экран
  return /iPhone|iPad|iPod/.test(ua) || (ua.indexOf('Macintosh') !== -1 && window.navigator.maxTouchPoints > 1)
}

export function setupPwa() {
  pwaState.standalone = isStandalone()
  pwaState.ios = detectIos()

  window.addEventListener('beforeinstallprompt', (event) => {
    // своё приглашение вместо мини-панели браузера: кнопка в кабинете
    event.preventDefault()
    installEvent = event
    pwaState.canInstall = true
  })
  window.addEventListener('appinstalled', () => {
    installEvent = null
    pwaState.canInstall = false
    pwaState.standalone = true
  })
  try {
    window.matchMedia('(display-mode: standalone)').addEventListener('change', () => {
      pwaState.standalone = isStandalone()
    })
  } catch (e) {
    // старые браузеры: состояние обновится при следующей загрузке
  }

  // просим браузер не очищать данные сайта (вход хранится в них): иначе на нехватке места они могут пропасть
  try {
    if (navigator.storage && navigator.storage.persist) navigator.storage.persist()
  } catch (e) {
    // не поддерживается: вход всё равно хранится в localStorage
  }

  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/sw.js').then(
        () => { pwaState.worker = true },
        () => { pwaState.worker = false }
      )
    })
  }
}

// Предложить установку (по нажатию кнопки). Возвращает 'accepted' | 'dismissed' | 'unavailable'.
export function installApp() {
  if (!installEvent) return Promise.resolve('unavailable')
  const event = installEvent
  installEvent = null
  pwaState.canInstall = false
  event.prompt()
  return event.userChoice.then((choice) => choice.outcome).catch(() => 'dismissed')
}
